// Shared react-select filter: match every typed word against the option's
// termMatch (when present) or label. Coerces to string first — labels can be
// undefined, numbers, or React elements (e.g. creatable "create new" rows),
// which crashed the old per-component filters mid-keystroke (#327).
const filterOption = (option, rawInput) => {
  if (!rawInput) {
    return true;
  }

  const haystack = String(
    option?.data?.termMatch ?? option?.label ?? ''
  ).toLowerCase();

  return rawInput
    .split(' ')
    .filter(Boolean)
    .every((word) => haystack.includes(word.toLowerCase()));
};

export default filterOption;
